import {Text} from '../../components/Text';

import type {ChartDatum, TooltipParams} from './utils/types';
import type {useTooltipInPortal} from '@visx/tooltip';

type TooltipComponent = ReturnType<
  typeof useTooltipInPortal
>['TooltipInPortal'];

type Props<T extends ChartDatum> = {
  Component: TooltipComponent;
  helpers: TooltipParams<T>;
  renderTooltipLabel: (item: T) => {
    title: React.ReactNode;
    value: React.ReactNode;
  };
};
export function ChartTooltip<T extends ChartDatum>({
  Component,
  helpers,
  renderTooltipLabel,
}: Props<T>): React.JSX.Element | null {
  if (!helpers.tooltipData) return null;

  const {tooltipData} = helpers;

  const {title, value} = renderTooltipLabel(tooltipData);

  return (
    <Component
      top={helpers.tooltipTop}
      left={helpers.tooltipLeft}
      className="rounded-md! bg-slate2! px-2! py-1! font-semibold! text-slate12! shadow-md! dark:outline-1 dark:outline-slate6 dark:outline-solid"
    >
      <Text className="text-sm">{title}</Text>
      <Text className="text-xs text-slate11">{value}</Text>
    </Component>
  );
}

ChartTooltip.displayName = 'ChartTooltip';
